import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form';
import { FormControl, Grid, InputLabel, MenuItem, Select, Button } from '@material-ui/core';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import renderDecimalTextField from '../Complements/renderDecimalTextFiel';

const validate = values => {
    const error  = {}
    if (!values.amount) {
        error.amount = "El monto es un campo obligatorio"
    }
    if (parseFloat(values.amount) < 0) {
        error.amount = "El monto debe ser mayor a 0"
    }
    return error
}

class DonationsFoundationsForm extends Component {

    
    render() {
        const {  handleSubmit,  valid, submitting, cancelButton, foundationSelected, handleFoundationChange, foundations  } = this.props;
        
        return (
            <React.Fragment>
                <form  onSubmit={ handleSubmit }>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12} lg={12} xl={12}>
                                <FormControl variant="outlined" style={{minWidth: '100%'}}>
                                    <InputLabel id="certificateType">{'Fundación'}</InputLabel>
                                    <Select
                                        labelId="foundation"
                                        id="foundation"
                                        label="Fundación"
                                        value={foundationSelected}
                                        onChange={ handleFoundationChange }
                                    >
                                        {
                                            foundations.map(row => {
                                                return <MenuItem key= {row.Secuencial} value={row}>{row.Nombre}</MenuItem>
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="amount"
                                id="amount"
                                simbol='$'
                                component={ renderDecimalTextField }
                                label="Monto"
                                fullWidth
                                color = {"#161616"}
                            />
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button variant="contained" type="submit"
                                disabled={!valid || submitting}
                                color = "primary"
                                fullWidth
                                //color="primary"
                                // className={classes.submit}
                                >
                                Continuar
                            </Button>
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button variant="contained" onClick = {cancelButton} fullWidth style = {{
                                    fontSize: '0.6rem',
                                    color: '#1a1919',
                                    borderLeft: '3px solid rgba(255, 198, 0)',
                                    backgroundColor: "white",
                                    borderRadius: '0px',
                                    fontFamily: 'Ubuntu',
                                    fontWeight: 'bold'
                                }}
                            >
                                Cancelar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </React.Fragment>
        )
    }
}

const DonationsFoundationsReduxForm = reduxForm(
    {
        form: 'DonationsFoundationsForm',
        validate
    }
)(DonationsFoundationsForm)

export default setPropsAsInitial(DonationsFoundationsReduxForm)